import styled from 'styled-components';
import { Dialog, DialogContent, DialogTitle, DialogActions } from '@mui/material';

const CustomDialog = styled(Dialog)`
	width: 100%;
	overflow: auto;
	& .MuiDialog-paper {
		padding: 30px;
	}
`;

const CustomDialogTitle = styled(DialogTitle)`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 15px;
	padding-bottom: 25px;
`;

const CustomDialogContent = styled(DialogContent)`
	display: flex;
	flex-direction: column;
	justify-content: center;	
	color: rgba(0, 0 ,0, 0.60)
	text-align: left;
	padding:15px 20%;

`;

const CustomDialogActions = styled(DialogActions)`
	padding-top: 25px;
`;

export default {
	CustomDialog,
	CustomDialogTitle,
	CustomDialogContent,
	CustomDialogActions
};
